module.exports = __webpack_public_path__ + "img/ug.6d6f8896.svg";